// import Loadable from "app/components/Loadable";
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const FeedCompanyList = Loadable(lazy(() => import("./FeedCompanyList")));
const FeedCompanyForm = Loadable(lazy(() => import("./FeedCompanyForm")));

const feedCompanyRoutes = [
  {
    path: "/FeedCompany/FeedCompanyList",
    element: <FeedCompanyList />,
    permission: PERMISSIONS.FeedCompanies.Menu,
  },
  {
    path: "/FeedCompany/FeedCompanyForm",
    element: <FeedCompanyForm />,
  },
  {
    path: "/FeedCompany/FeedCompanyForm/:feedCompanyId",
    element: <FeedCompanyForm />,
  },
];
export default feedCompanyRoutes;
